import { getFCMToken } from "./config";
import { AuthApi } from "../api/auth";

const FCM_TOKEN_KEY = "fcm_token";
const FCM_TOKEN_SENT_KEY = "fcm_token_sent";

export const initializeFCMToken = async (): Promise<string | null> => {
  try {
    const existingToken = localStorage.getItem(FCM_TOKEN_KEY);
    const tokenSent = localStorage.getItem(FCM_TOKEN_SENT_KEY);

    if (existingToken && tokenSent === "true") {
      return existingToken;
    }

    const token = await getFCMToken();
    
    if (token) {
      localStorage.setItem(FCM_TOKEN_KEY, token);
      return token;
    }

    return null;
  } catch (error) {
    console.error("Error initializing FCM token:", error);
    return null;
  }
};

export const sendFCMTokenToServer = async (userId: string): Promise<boolean> => {
  try {
    if (!userId) {
      console.warn("User ID is required to send FCM token");
      return false;
    }

    const token = await initializeFCMToken();
    
    if (!token) {
      console.warn("FCM token not available");
      return false;
    }

    const tokenSentKey = `${FCM_TOKEN_SENT_KEY}_${userId}`;
    const tokenSent = localStorage.getItem(tokenSentKey);
    if (tokenSent === "true") {
      const existingToken = localStorage.getItem(FCM_TOKEN_KEY);
      if (existingToken === token) {
        return true;
      }
    }

    await AuthApi.registerFCMToken(userId, token);
    
    localStorage.setItem(tokenSentKey, "true");
    
    console.log("FCM token sent to server successfully for user:", userId);
    return true;
  } catch (error) {
    console.error("Error sending FCM token to server:", error);
    return false;
  }
};

export const clearFCMToken = () => {
  localStorage.removeItem(FCM_TOKEN_KEY);
  localStorage.removeItem(FCM_TOKEN_SENT_KEY);
};

export const getStoredFCMToken = (): string | null => {
  return localStorage.getItem(FCM_TOKEN_KEY);
};

